<!-- ======== banner image starts ======== -->
<div id="main-wrapper h-60" *ngIf="event.bannerImage">
    <div class="site-wrapper-reveal">
        <div class="position-relative w-100">
            <div class="d-flex align-items-center h-100 w-100">
                <div class="container-fluid p-0 ">
                    <img [src]="event.bannerImage ? getImageUrl(event.bannerImage) : '../../../assets/images/meetup-images/Altbanner.jpg'"
                        alt="Banner-mit" class="img img-responsive w-100 h-60 position-relative" style="height:500px"
                        width="100%" alt="banner-mit" />

                    <div class="overlay" style="clip-path: polygon(0 0, 80% 0, 100% 100%, 0% 100%)">
                        <div class="text py-5 px-4">
                            <div class="align-items-center banner-content-title  global_title global_banner_title  title_banner_content"
                                style="padding-right: 13%;">
                                {{ event.name}}
                            </div>
                            <!-- <h1 style=" font-size:2vw !important; color:#ffffff">{{ event.name}}</h1> -->
                            <div class="global_sub_title global_banner_subtitle text-align-left mt-3"
                                style="padding-right:20%">
                                <div>{{ event.topic
                                    }}</div>
                            </div>
                            <div class="col pt-lg-3 pt-5 mt-lg-3" *ngIf="isPastEvent == false">
                                <div class=""><i class="fas fa-calendar-alt px-2 m-0"></i> {{ event.startDate | date:
                                    'fullDate' }} - {{
                                    event.startDate | date: 'shortTime' }} Onwards - {{ event.venue }}</div>
                                <div class="py-3">
                                    <a (click)="scrollToSection('eventForm')"
                                        class="global_button  col text-white white_button">
                                        <div class="dub-arrow"><img src="../../../assets/images/button/arrowWhite.png"
                                                alt="arrow_img" /></div>
                                        Register Now
                                    </a>
                                </div>
                            </div>
                            <div class="col pt-lg-3 pt-5 mt-lg-3" *ngIf="isPastEvent == true">
                                <div class="">Conducted On: {{ event.startDate | date:
                                    'fullDate' }} - {{ event.venue }}</div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
<style>
    .gallery {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        justify-content: center;
    }

    .gallery figure {
        margin: 0;
        border: 1px solid #ddd;
        border-radius: 8px;
        overflow: hidden;
        width: 300px;
        /* Fixed width */
        height: 300px;
        /* Fixed height */
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .gallery img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .gallery figcaption {
        padding: 8px;
        background-color: #f8f8f8;
        text-align: center;
        font-size: 14px;
        color: #333;
    }
</style>
<style>#gallery {
    padding-top: 40px;
  }
  
  @media screen and (min-width: 991px) {
    #gallery {
      padding: 60px 30px 0 30px;
    }
  }
  
  .img-wrapper {
    position: relative;
    margin-top: 15px;
  }
  
  .img-wrapper img {
    width: 100%;
  }
  
  .img-overlay {
    background: rgba(0, 0, 0, 0.7);
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    transition: opacity 0.6s;
  }
  
  .img-wrapper:hover .img-overlay {
    opacity: 1;
  }
  
  #overlay {
    background: rgba(0, 0, 0, 0.7);
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
    user-select: none;
  }
  
  #overlay img {
    margin: 0;
    width: 80%;
    height: auto;
    object-fit: contain;
    padding: 5%;
  }
  
  @media screen and (min-width: 768px) {
    #overlay img {
      width: 60%;
    }
  }
  
  @media screen and (min-width: 1200px) {
    #overlay img {
      width: 50%;
    }
  }
  
  #nextButton, #prevButton, #exitButton {
    color: #fff;
    font-size: 2em;
    transition: opacity 0.8s;
  }
  
  #nextButton:hover, #prevButton:hover, #exitButton:hover {
    opacity: 0.7;
  }
  
  @media screen and (min-width: 768px) {
    #nextButton, #prevButton, #exitButton {
      font-size: 3em;
    }
  }
  
  #exitButton {
    position: absolute;
    top: 15px;
    right: 15px;
  }
  </style>
<section id="gallery" *ngIf="isPastEvent == true && galleryImages">
    <div class="container">
      <div class="row">
        <div class="col-md-6 col-lg-6 col-sm-12 mb-5" *ngFor="let image of galleryImages">
          <div class="img-wrapper">
            <img [src]="getImageUrl(image.imageUrl)" (click)="openLightbox(image.imageUrl)">
            <div class="img-overlay" (click)="openLightbox(image.imageUrl)">
              <i class="fa fa-search-plus"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <div *ngIf="showOverlay" id="overlay" #overlay>
      <img #image [src]="imageSrc" alt="Lightbox Image">
      <div id="prevButton" (click)="showPrevImage()"><i class="fa fa-chevron-left"></i></div>
      <div id="nextButton" (click)="showNextImage()"><i class="fa fa-chevron-right"></i></div>
      <div id="exitButton" (click)="closeLightbox()"><i class="fa fa-times"></i></div>
    </div>
  </section>
<!-- Gallery Section -->
<!-- <section *ngIf="isPastEvent == true && galleryImages">


    
    <div class="gallery-container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center application_content_service global_section_header mt-2">Gallery</div>
                <div class="insights-subtitle global_sub_titles casestudy-subtitle my-3 my-lg-5 text-center">
                    <p><b>Get in on the excitement! Here's a quick peek at the fun and lively moments from our recent
                            events.</b></p>
                </div>

                <main class="gallery">
                    <figure *ngFor="let image of galleryImages">
                        <img [src]="getImageUrl(image.imageUrl)"
                            class="single-gallery__thum bg-item-images  bg-img" alt="r&d finance" />
                    </figure>

                   
                </main>


            </div>
        </div>
    </div>
</section> -->


<section *ngIf="isPastEvent == false" class="register-now" style="background-color: aliceblue;">
    <div class="container" id="eventForm">
        <div class="row py-4">
            <div class="col-md-12 col-lg-12 col-sm-12 col-12">
                <div class="overview_heading global_section_header text-center">
                    Register
                </div>
                <div class="software-text global_section_content text-center pt-2">
                    Secure your spot now and be at the forefront of revolutionizing GCCs in the hyperconnected age.
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12 intern_formcol" id='sectionOne'>
                <div class="border border-1  p-3 intern_forDiv">
                    <!-- <div class=" text-center m-1 mt-4 py-2 h1 sbtDiv" style="color:#182357; font-size:23px;">
                        <b>Submit your Details</b>
                    </div> -->
                    <form [formGroup]="form" (ngSubmit)="onSubmit()">

                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-sm-12">
                                <div class="form-floating internForm" style="height:60px">
                                    <input type="text" class="form-control my-4" formControlName="Name" id="Name"
                                        style="height:50px;" placeholder="Name*">
                                    <label for="Name" class="internship_label text-secondary">Name*</label>
                                    <div *ngIf="isFormControlInvalid('Name')" class="formError">{{
                                        getErrorMessage('Name') }}</div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-6 col-sm-12">
                                <div class="form-floating internForm" style="height:60px;">
                                    <input type="text" formControlName="College" id="College" class="form-control my-4"
                                        autocomplete="off" style="height:50px;" placeholder="College/Institute Name*">
                                    <label for="College" class="internship_label text-secondary">College/Institute
                                        Name*</label>
                                    <div *ngIf="isFormControlInvalid('College')" class="formError">{{
                                        getErrorMessage('College') }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-sm-12">
                                <div class="form-floating" style="height:70px">
                                    <input type="text" formControlName="Qualification" id="Qualification"
                                        class="form-control my-4" autocomplete="off" style="height:60px;"
                                        placeholder="Degree/Qualification*">
                                    <label for="Qualification"
                                        class=" internship_label text-secondary">Degree/Qualification*</label>
                                    <div *ngIf="isFormControlInvalid('Qualification')" class="formError">{{
                                        getErrorMessage('Qualification') }}</div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12">
                                <div class="form-floating  " style="height:60px; ">
                                    <input type="tel" formControlName="Phone" id="Phone" class="form-control my-4"
                                        autocomplete="off" style="height:50px;" placeholder="*Phone Number">
                                    <label for="Phone" class=" internship_label text-secondary">Phone*</label>
                                    <div *ngIf="isFormControlInvalid('Phone')" class="formError"> {{
                                        getErrorMessage('Phone') }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12">
                                <div class="form-floating " style="height:60px;">
                                    <input type="email" formControlName="Email" id="Email" class="form-control my-4"
                                        autocomplete="off" style="height:50px;" placeholder="*Email">
                                    <label for="Email" class=" internship_label text-secondary">Email*</label>
                                    <div *ngIf="isFormControlInvalid('Email')" class="formError"> {{
                                        getErrorMessage('Email') }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12 p-5">

                                <div class=" d-flex justify-content-end"
                                    style="height:50px; background: transparent linear-gradient(175deg, #9442EA 0% ) 0% 0% no-repeat padding-box!important; width: 100%;">
                                    <button type="submit" class="btn btn-lg text-white"
                                        id="submitBtn" style="height:50px;"> Apply Now</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

</section>

<!-- ======== banner ends ======== -->
<section *ngIf="isPastEvent == false">
    <div id="formpage" class="formpage" style="background-color: #ffff;" data-aos="fade-up">
        <div class="container ">
            <div class="row">
                <div class="col-lg-12 py-3 col-12">

                    <div style="color: #000; font-size: 33px; font-weight: 500;">
                        Meliorate Your Talent!
                    </div>
                    <div class="application_service-subcontent global_section_content pt-5">
                        <div>
                            Are you passionate about coding? Do you dream of showcasing your skills and making a mark in
                            the tech world? We are thrilled to announce an exciting opportunity for coders like
                            you! We are conducting a coding contest that aims to identify and celebrate coding talent.
                            This is your chance to shine, learn, and compete with fellow coding enthusiasts.

                        </div>
                        <h3 style="color: #AC59FD;" class="fs-1">Why Enroll?</h3>

                        <div class="mt-2">
                            <span style="color:#AC59FD; font-weight:bold">- Showcase Your Talent:</span>&nbsp;
                            This contest is the ideal platform to exhibit your coding skills to a wide audience,
                            including industry leaders and peers. Distinguish yourself and build your reputation.
                        </div>
                        <div class="mt-2">
                            <span style="color:#AC59FD; font-weight:bold">- Professional Networking:</span>&nbsp;
                            Gain exposure and network with professionals from leading companies. This is an excellent
                            opportunity to connect with potential employers and collaborators.
                        </div>
                        <div class="mt-2">
                            <span style="color:#AC59FD; font-weight:bold">- Business Webinars:</span>&nbsp;
                            Participants will have access to exclusive webinars focusing on business strategies,
                            industry insights, and career development. These webinars are invaluable for gaining
                            knowledge and staying updated with the latest trends in the professional world.
                        </div>
                        <div class="mt-2">
                            <span style="color:#AC59FD; font-weight:bold">- Attractive Cash Prizes:</span>&nbsp;
                            Participants have the chance to win substantial cash prizes. It’s not just about the
                            competition it's also about acknowledging and rewarding your hard work and talent.
                        </div>

                        <h3 style="color: #AC59FD;" class="fs-1 mt-4">How to meet the Corporate Achievers:</h3>
                        <div class="mt-2">
                            1. Fill out the participation form with your details to enroll in the contest.<br>
                            2. Upon registration, you will receive comprehensive information about the contest,
                            including the schedule and guidelines.<br>
                            3. Be prepared to showcase your coding prowess at the designated time!
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </div>
</section>
<section class="overview-section" *ngIf="event.editorContent">
    <div class="content">
        <div class="container">
            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12">
                    <div class="overview_heading global_section_header  text-left">

                        Highlights
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12">
                    <div class="overview_content sub-content global_section_content application_subcontent ">

                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12 ">
                                <div id="contentcode" [innerHTML]="event.editorContent">

                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-12 col-md-6 col-sm-12">
                    <div class="overview-img">
                        <img src="../../../assets/images/meetup-images/overview.webp" class="img" alt="meetup" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>




<section  class="speakers">
    <div class="container" *ngIf="event.selectedSpeakers.length">
        <div class="row">
            <div class="col-12 ">
                <div class="overview_heading global_section_header text-center pb-4" style="font-weight: 600;">
                    Speakers
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-lg-6 col-sm-12 mb-5" *ngFor="let speaker of event.selectedSpeakers">
                <mat-card class=" speakerCard ">
                    <mat-card-header >
                        <div mat-card-avatar class="example-header-image text-align-center"
                            [ngStyle]="{'background-image': 'url(' + getImageUrl(speaker.imageUrl) + ')'}"></div>
                        <mat-card-title class="speakerName">{{ speaker.name }}</mat-card-title>
                        <mat-card-subtitle>{{ speaker.bio }}</mat-card-subtitle>
                    </mat-card-header>

                </mat-card>
            </div>

        </div>
    </div>
</section>
<!-- ======= speakers section ends ======= -->





<!-- 
<section>
    <div class="trained">
        <div class="container-fluid">
            <div class="row">

            </div>
            <div class="Testimonials">
                <div class="container " id="testimonials-logos">
                    <div class="row" id="testimonials-logos">

                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="subSectionTitle global_section_header awards">
                                Our Accreditations
                            </div>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-6 logo-container">
                            <div class="swiper-slide brand-logo brand-logo--slider">
                                <div class="logo">
                                    <img src="../../../assets/images/mit-mainpage/WBENC_Logo.png" class="img-fluid"
                                        alt="curorclogo">
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-6 logo-container">
                            <div class="swiper-slide brand-logo brand-logo--slider">
                                <div class="logo">
                                    <img src="../../../assets/images/mit-mainpage/WOMEN_Logo.png" class="img-fluid"
                                        alt="curorclogo">
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-6 logo-container">
                            <div class="logo">
                                <img src="../../../assets/images/mit-mainpage/NMSDC_Logo.png" class="img-fluid"
                                    alt="curorclogo">
                            </div>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-6 logo-container">
                            <div class="logo">
                                <img src="../../../assets/images/mit-mainpage/highly_Logo.png" class="img-fluid"
                                    alt="curorclogo">
                            </div>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-6 logo-container">
                            <div class="logo">
                                <img src="../../../assets/images/mit-mainpage/A+-Rating_Logo.png" class="img-fluid"
                                    alt="curorclogo">
                            </div>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-6 logo-container">
                            <div class="logo">
                                <img src="../../../assets/images/mit-mainpage/E-verify_Logo.png" class="img-fluid"
                                    alt="curorclogo">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br><br>
</section> -->

<!-- <section class="sponsors">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="overview_heading global_section_header text-center">
                    Sponsors
                </div>
                <div class="col-12 text-center pt-2">Who Believe in Us</div>
            </div>
        </div>
        <div class="row mt-5"> 
    <div class="col-md-4 Enterprise ">
      <div class="card-body1 text-end">
        <h6>Enterprise Reinvention Partner</h6>
    
      </div>
      <div class="row">
        <div class="col-6">
          <div class="sapient">
            <img class="img-fluid" src="../../../assets/images/singleevent-images/publicis-sapient.jpg" alt="accenture" />
          </div>
        </div>
        <div class="col-6">
          <div class="sapient1">
            <img class="img-fluid" src="../../../assets/images/singleevent-images/publicis-sapient.jpg" alt="accenture" />
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <div class="sapient">
            <img  class="img-fluid" src="../../../assets/images/singleevent-images/publicis-sapient.jpg" alt="accenture" />
          </div>
        </div>
        <div class="col-6">
          <div class="sapient1">
            <img  class="img-fluid" src="../../../assets/images/singleevent-images/publicis-sapient.jpg" alt="accenture" />
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4 Enterprise">
      <div class="card-body2 text-end">
        <h6>Digits business transformations</h6>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <div class="sapient2">
            <img  class="img-fluid" src="../../../assets/images/singleevent-images/publicis-sapient.jpg" alt="accenture" />
          </div>
        </div>
        <div class="col-6">
          <div class="sapient3">
            <img class="img-fluid" src="../../../assets/images/singleevent-images/publicis-sapient.jpg" alt="accenture" />
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <div class="sapient2">
            <img class="img-fluid" src="../../../assets/images/singleevent-images/publicis-sapient.jpg" alt="accenture" />
          </div>
        </div>
        <div class="col-6">
          <div class="sapient3">
            <img class="img-fluid" src="../../../assets/images/singleevent-images/publicis-sapient.jpg" alt="accenture" />
          </div>
        </div>
      </div>
    </div>
  </div></div></section> -->
<section class="sponsors" *ngIf="event.meetupType==true">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="overview_heading global_section_header text-center">
                    Sponsors
                </div>
                <div class="col-12 text-center pt-2">Who Believe in Us</div>
            </div>
        </div>
        <div class="flex-container">
            <div><img class="img-fluid" src="../../../assets/images/singleevent-images/publicis-sapient.jpg"
                    alt="publicis-sapient" /></div>
            <div><img class="img-fluid" src="../../../assets/images/singleevent-images/publicis-sapient.jpg"
                    alt="publicis-sapient" /></div>
            <div><img class="img-fluid" src="../../../assets/images/singleevent-images/publicis-sapient.jpg"
                    alt="publicis-sapient" /></div>
        </div>
    </div>
</section>



<!--====== Carousels Start Here ======-->
<section class="employee-carosels"  *ngIf="isPastEvent == true" >
    <div class="testimonial-slider-area py-5">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="Training-areas ">
                        <div class="global_section_header"> The Inside Scoop: Attendees Testimonials </div>

                        <!-- <div class="benefit_heading">The Inside Scoop: Employee Testimonials</div> -->
                        <p style="text-align: center; padding: 30px">Uncover the inside scoop on working with us
                            from those who know Us.</p>
                    </div>
                    <div class="testimonial-slider">
                       
                        <swiper-container #empSwiperContainer class="testimonial-slider__container" slides-per-view="2"
                            [autoplay]="{ delay: 3000 }" [pagination]="{ el: '.swiper-pagination', clickable: true }"
                            [loop]="true">
                            <swiper-slide class="employee-slider">
                                <div class="recognition-employees testimonial-slider__one wow move-up">
                                    <div class="testimonial-slider--info">
                                        <div class="global_section_content recognition-slider testimonial-slider__text">
                                            <b>"Maganti IT has been a transformative journey for my career</b>. Their
                                            comprehensive training programs equipped me with cutting-edge skills and
                                            industry insights, enabling me to excel in the competitive IT landscape. The
                                            personalized mentorship and hands-on experience I received during my
                                            internship were invaluable. Thanks to Maganti IT, I am now confidently
                                            shaping my path in the tech world."
                                        </div>
                                    </div>
                                    <div class="testimonial-slider__author"
                                        style="display: flex; justify-content: start;padding: 1rem;">
                                        <img src="../../../assets/images/recognition/placeholder.png"
                                            class="author-image img-fluid" alt="recognition">
                                        <div class="grid gap-1" style="padding:0 2rem;">
                                            <h6>
                                                Meghanath.</h6>
                                            <span> proud Alumn</span>
                                        </div>
                                    </div>
                                </div>
                            </swiper-slide>
                            <swiper-slide class="employee-slider">
                                <div class="recognition-employees testimonial-slider__one wow move-up">
                                    <div class="testimonial-slider--info">
                                        <div class="global_section_content recognition-slider testimonial-slider__text">
                                            <b>"Choosing Maganti IT for my career training was an excellent
                                                decision.</b> Their
                                            training programs are top-notch, providing in-depth knowledge and
                                            practical skills that are directly applicable to real-world scenarios. The
                                            experienced instructors and interactive learning approach made the learning
                                            journey enjoyable and effective.
                                            Thanks to Maganti IT, I am now well-prepared and confident to tackle the
                                            challenges of my IT career."
                                        </div>
                                    </div>

                                    <div class="testimonial-slider__author"
                                        style="display: flex; justify-content: start;padding: 1rem;">
                                        <img src="../../../assets/images/recognition/placeholder.png"
                                            class="author-image img-fluid" alt="recognition">
                                        <div class="grid gap-1" style="padding:0 2rem;">
                                            <h6>
                                                Swati Reddy,</h6>
                                            <span> Application developer,</span>
                                        </div>
                                    </div>
                                </div>
                            </swiper-slide>
                            <swiper-slide class="employee-slider">
                                <div class="recognition-employees testimonial-slider__one wow move-up">
                                    <div class="testimonial-slider--info">
                                        <div class="global_section_content recognition-slider testimonial-slider__text">
                                            <b> "The guidance and support I received from my mentors were instrumental
                                                in my
                                                career growth.</b> Their insights, advice,
                                            and personalized attention helped me navigate the complexities of the IT
                                            industry with confidence.
                                            Thanks to Maganti IT, I not only gained technical skills but also had the
                                            privilege of learning from the best mentors in the field."
                                        </div>
                                    </div>

                                    <div class="testimonial-slider__author"
                                        style="display: flex; justify-content: start;padding: 1rem;">
                                        <img src="../../../assets/images/recognition/placeholder.png"
                                            class="author-image img-fluid" alt="recognition">
                                        <div class="grid gap-1" style="padding:0 2rem;">
                                            <h6>
                                                S. Kavya</h6>
                                            <span> Data Scientist Intern</span>
                                        </div>
                                    </div>
                                </div>
                            </swiper-slide>

                            <swiper-slide class="employee-slider">
                                <div class="recognition-employees testimonial-slider__one wow move-up">
                                    <div class="testimonial-slider--info">
                                        <div class="global_section_content recognition-slider testimonial-slider__text">
                                            <b> "It has been a transformative experience for me, especially after a
                                                career
                                                gap.</b> Their program catered perfectly to my needs,
                                            helping me bridge the gap and regain my professional confidence. The
                                            supportive mentors and relevant training empowered me to reenter the
                                            workforce with updated skills.
                                            Thanks to Maganti IT, I successfully transitioned back into my career and am
                                            now thriving in the IT industry once again".
                                        </div>
                                    </div>

                                    <div class="testimonial-slider__author"
                                        style="display: flex; justify-content: start;padding: 1rem;">
                                        <img src="../../../assets/images/recognition/placeholder.png"
                                            class="author-image img-fluid" alt="recognition">
                                        <div class="grid gap-1" style="padding:0 2rem;">
                                            <h6>
                                                Ramesh Chandra,</h6>
                                            <span>Full Stack Developer</span>
                                        </div>
                                    </div>
                                </div>
                            </swiper-slide>
                        </swiper-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!--====== Carousels End Here ======-->
<!--====== Join Our Team Section Start Here ======-->
<!-- This Was Hided -->
<section class=" internship-bottom h-100vh">
    <div class="w-100" id="intern_bottom">
        <img src="../../../assets/images/intern/intern-bottom.png" width="100%" class="internship_cultureimage"
            alt="intership_team" />
        <div class="intern_bootom_box">
            <div class="intern_bottom_box_header text-center mt-3" style="font-family: 'Comfortaa'; font-size:35px;">
                Join Our Team</div>
            <div class="intern_bottom_box_text text-center global_section_content">We're a close-knit team of
                enthusiastic tech-innovators, strategists, and creative thinkers. Think you'll fit in just fine?
            </div>
            <div class="text-center col pt-lg-4 pt-5 mt-lg-5">
             

                <a href="contact" class="global_button  text-left col pt-5 text-white white_button">
                    <div class="dub-arrow"><img src="../../../assets/images/button/arrowWhite.png" alt="arrowWhite" /></div>
                    EXPLORE JOBS
                </a>
            </div>
        </div>
    </div>


</section>






<div class="modal" id="myModal46">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <div class="career-modal global_sub_title mx-5 ">Software Engineering</div>
                <!-- <button type="button" class=" career_closebutton" data-dismiss="modal">&times;</button> -->
            </div>
            <div class="modal-body">
                <div class='page-meta career_popupcontent'>

                </div>
                <!-- <hr/> -->
                <div class="career_popupcontent">Get trained with an internship in Software engineering. Begin your
                    first career and grow to higher roles such as Software Development Engineer (In Test), Project/
                    Technical Lead, Project/Technical Manager, Technical Architect, and more either at a module,
                    subsystem, system, application, solution/product or project level.</div>
                <div class="global_sub_title job-description mt-4"><b>Job duties</b></div>
                <div class="career_popupcontent">

                    <div class="Contents">
                        <!-- <div class="global_section_content ouropinion_subcontent">Begin your first career as Software Engineer or Digital Systems Analyst, with the potential to grow in the career to higher roles such as Software Development Engineer (In Test), Project/ Technical Lead, Project/Technical Manager, Technical Architect, and more either at a module, subsystem, system, application, solution/product or project level.</div> -->
                        <div class="global_section_content ouropinion_subcontent">
                            <b>Eligibility:</b>Bachelor’s Degree in Computer Science, Information Technology,
                            Information Systems, Electrical, Electronics, Mechanical Engineering or other STEM
                            Majors like Math & Science.
                        </div><br>
                        <b>What you’ll learn:</b>
                        <ul style="list-style-type:disc; line-height: 30px; color: black;">
                            <li> Manage individual project priorities, deadlines and deliverables.</li>
                            <li>Write design documents and participate in design reviews.</li>
                            <li>Setup environment and participate in testing/ trouble shooting existing software
                                issues and implement as per the change management process and bug fixes.</li>
                            <li>Optimize developed systems for performance and reliability.</li>
                            <li>Operating System provisioning and Storage configuration</li>
                            <li>Develop functions, scripts, stored procedures and triggers to support application
                                development.</li>
                            <li>Use applicable methodologies, modeling/ estimating techniques, tools, applications,
                                systems, software and/or databases to perform assigned tasks. </li>
                        </ul>


                        <!-- <div class="global_section_content ouropinion_subcontent">
                                <h6>Career Path</h6> Software Engineering
                            </div> -->
                    </div>
                </div>
                <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                <div class="career_popupcontent">hr&nbsp;mitresource.com</div>
            </div>
            <div class="modal-footer">
                <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>


<div class="modal" id="myModal47">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <div class="career-modal global_sub_title mx-5 ">Cloud Services</div>
                <!-- <button type="button" class=" career_closebutton" data-dismiss="modal">&times;</button> -->
            </div>
            <div class="modal-body">
                <div class='page-meta career_popupcontent'>

                </div>
                <!-- <hr/> -->
                <div class="career_popupcontent">
                    <div class="Contents">
                        <div class="global_section_content ouropinion_subcontent">
                            Start your journey on Cloud computing with training and internship opportunities. Begin
                            as a Cloud Administrator to steadily advance your career, vertically to Cloud Architect,
                            or explore opportunities to grow to other technologies.
                        </div>
                        <div class="global_section_content ouropinion_subcontent">
                            <b>Eligibility:</b> Bachelor’s Degree in Computer Science, Information Technology,
                            Information Systems, Electrical, Electronics, Mechanical Engineering or other STEM
                            Majors like Math & Science.
                            <p>As a Cloud Administrator Intern, you would learn and perform the following
                                responsibilities:</p>
                        </div><br>
                        <b>What you’ll learn:</b>As a Cloud Administrator Intern, you would learn and perform
                        following responsibilities.
                        <ul style="list-style-type:disc; line-height: 30px; color: black;">

                            <li>Gain hands-on experience setting up and managing scalable, secure, and efficient
                                cloud infrastructure. Learn resource allocation for optimized utilization and
                                cost-effectiveness.</li>
                            <li>Acquire skills in implementing robust security measures to safeguard cloud-based
                                systems and data. Understand monitoring techniques to identify bottlenecks and
                                enhance overall system efficiency.</li>
                            <li>Master the essentials of designing and implementing backup and recovery strategies
                                for cloud-based data and applications. Explore collaborative tools for effective
                                communication in a cloud-based environment.</li>
                            <li>Develop problem-solving skills to address issues related to cloud infrastructure,
                                ensuring seamless operations. Cultivate a habit of thorough documentation for
                                configurations, processes, and troubleshooting steps.</li>
                            <li>Interact cross-functionally and conduct end-to-end analysis, from processing data to
                                presenting results, in collaboration with various teams. Utilize analytical methods
                                on large, complex datasets for open-ended problem-solving.</li>
                            <li>Collaborate closely with engineers to identify opportunities for and assess
                                improvements to organizational products.</li>
                        </ul>


                        <!-- <div class="global_section_content ouropinion_subcontent">
                                <h6>Career Path</h6> Cloud Services
                            </div> -->
                    </div>

                </div>
                <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
                <div class="career_popupcontent">Bachelor of Science or related field required. </div>

                <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                <!-- <div class="career_popupcontent">hr@mitresource.com</div> -->
            </div>
            <div class="modal-footer">
                <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>


<div class="modal" id="myModal48">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <div class="career-modal global_sub_title mx-5 ">FullStack Development</div>
            </div>
            <div class="modal-body">
                <div class='page-meta career_popupcontent'>

                </div>
                <div class="career_popupcontent">
                    <div class="Contents">
                        <div class="global_section_content ouropinion_subcontent">
                            Bachelor’s Degree in Data Science, Math, Statistics, Computer Science, Information
                            Systems or Information Technology.
                            Begin as a Cloud Administrator to steadily advance your career, vertically to Cloud
                            Architect, or explore opportunities to grow to other technologies.
                        </div>
                        <div class="global_section_content ouropinion_subcontent">
                            <b>Eligibility:</b> Bachelor’s Degree in Computer Science, Information Technology,
                            Information Systems, Electrical, Electronics, Mechanical Engineering or other STEM
                            Majors like Math & Science.
                        </div>
                        <b>What you’ll learn:</b> As a Full Stack development Intern, you would learn and perform
                        following responsibilities.
                        <ul style="list-style-type:disc; line-height: 30px; color: black;">

                            <li>Participate in the complete software development lifecycle, from concept and design
                                to testing and deployment. </li>
                            <li>Learn and apply skills in building responsive and user-friendly interfaces using
                                modern web technologies such as HTML, CSS, and JavaScript. </li>
                            <li>Gain proficiency in server-side scripting, database management, and server
                                deployment to ensure seamless functionality and performance. </li>
                            <li>Acquire skills in designing and managing databases to ensure efficient storage and
                                retrieval of data.</li>
                            <li>Learn to create and integrate APIs, facilitating communication between different
                                parts of a web application.</li>
                            <li>Understand and utilize version control systems like Git for efficient collaboration
                                and code management. </li>
                            <li>Develop skills in testing code for functionality, identifying and resolving bugs to
                                ensure the reliability of applications.</li>
                            <li>Work collaboratively within a team, participating in code reviews and contributing
                                to the overall success of the development projects.</li>
                            <li>Learn and implement coding standards, best practices, and industry trends to ensure
                                high-quality and maintainable code.</li>
                            <li>Stay updated on emerging technologies and trends in full-stack development,
                                fostering a culture of continuous learning and improvement.</li>
                        </ul>


                    </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>


<div class="modal" id="myModal49">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <div class="career-modal global_sub_title mx-5 ">Testing</div>
                <!-- <button type="button" class=" career_closebutton" data-dismiss="modal">&times;</button> -->
            </div>
            <div class="modal-body">
                <div class='page-meta career_popupcontent'>

                </div>
                <!-- <hr/> -->
                <div class="career_popupcontent">
                    <div class="Contents">
                        <div class="global_section_content ouropinion_subcontent">
                            <b>Eligibility:</b> Bachelor’s Degree in Computer Science, Information Technology,
                            Information Systems, Electrical, Electronics, Mechanical Engineering or other STEM
                            Majors like Math & Science.
                            <p>As a Testing Intern, you will acquire valuable skills and knowledge in the field of
                                software testing. Your learning experience will encompass the following key areas:
                            </p>
                        </div> <br>
                        <b>What you’ll learn:</b> As a Cloud Administrator Intern, you would learn and perform
                        following responsibilities.

                        <ul style="list-style-type:disc; line-height: 30px; color: black;">
                            <li> Understand different testing methodologies, such as manual testing, automated
                                testing, and performance testing, to ensure comprehensive coverage of software
                                quality assurance.</li>
                            <li>Learn to create effective test plans and documentation, outlining the testing
                                strategy, scope, and test cases for various software components.</li>
                            <li>Develop the skill of designing clear and comprehensive test cases that cover
                                different scenarios to validate software functionality.</li>
                            <li>Familiarize yourself with automated testing tools and frameworks to enhance testing
                                efficiency and repeatability.</li>
                            <li>Understand the importance of regression testing and learn techniques to ensure that
                                new developments do not adversely affect existing functionalities.</li>
                            <li>Gain insights into performance testing methodologies to evaluate the responsiveness,
                                speed, and overall stability of software applications under varying conditions.</li>
                            <li>Learn about the life cycle of defects, from identification to resolution, and the
                                importance of clear communication between testers and developers.</li>
                            <li>Work collaboratively within a development team, participating in discussions, and
                                contributing insights to improve the overall software quality.</li>
                            <li>Embrace a culture of continuous improvement, staying updated on the latest testing
                                tools, methodologies, and industry best practices.</li>
                        </ul>

                        <!-- <div class="global_section_content ouropinion_subcontent">
                                <h6>Career Path</h6> Cloud Services
                            </div> -->
                    </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<div class="modal" id="myModal50">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <div class="career-modal global_sub_title mx-5 ">AI/ML</div>
                <!-- <button type="button" class=" career_closebutton" data-dismiss="modal">&times;</button> -->
            </div>
            <div class="modal-body">
                <div class='page-meta career_popupcontent'>
                    <!-- <div class='row'>
                    <div class='col-xs-12 col-sm-3 py-0'>
                        <div><span class='c-orange job-career-title'>Locations:</span> &nbsp; Waterbury - USA</div>
                    </div>
                    <div class='col-xs-12 col-sm-2 py-0  w-20'>
                        <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                    </div>
                    <div class='col-xs-12 col-sm-3 py-0 w-30'>
                        <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp;  November 21,2023</div>
                    </div>
                    <div class='col-xs-12 col-sm-3 py-0'>
                        <div><span class='c-orange job-career-title'>End Date:</span> &nbsp;  December  29,2023</div>
                    </div>
                </div> -->
                </div>
                <!-- <hr/> -->
                <div class="career_popupcontent">
                    <div class="Contents">
                        <div class="global_section_content ouropinion_subcontent">
                            <b>Eligibility:</b> Bachelor’s Degree in Data Science, Math, Statistics, Computer
                            Science, Information Systems or Information Technology.
                            Those who begin as Entry Level Data Engineers can pursue a career in Data Engineering,
                            Data Analysis, or Data Science and eventually advance to
                            become Technical Architects, Solution Architects, Chief Data Scientists, or to lead the
                            entire practise.<br>
                            <p> As an AI/ML Intern, you will gain valuable insights and skills in the dynamic field
                                of Artificial Intelligence and Machine Learning. Here's what you can expect to
                                learn. </p>
                            <b>What you’ll learn:</b>

                            <ul style="list-style-type:disc; line-height: 30px; color: black;">
                                <li> Acquire a solid understanding of the foundational concepts and principles
                                    behind Artificial Intelligence and Machine Learning.</li>
                                <li>Learn the crucial step of cleaning and transforming raw data into a suitable
                                    format for machine learning models.</li>
                                <li>Understand the principles of both supervised learning (classification,
                                    regression) and unsupervised learning (clustering, dimensionality reduction).
                                </li>
                                <li>Gain hands-on experience in developing machine learning models using popular
                                    frameworks and libraries such as TensorFlow or PyTorch.</li>
                                <li>Model Evaluation: Learn how to assess the performance of machine learning
                                    models, including metrics like accuracy, precision, recall, and F1 score.</li>
                                <li>Understand the importance of feature selection and engineering to enhance the
                                    performance of machine learning models. </li>
                                <li>Dive into the world of deep neural networks, learning about architectures like
                                    convolutional neural networks (CNNs) and recurrent neural networks (RNNs).</li>
                                <li>Explore the applications of machine learning in understanding and processing
                                    human language.</li>
                                <li>Gain insights into how mUnderstand the ethical implications of AI/ML, including
                                    bias in algorithms and responsible AI practices.achine learning is applied in
                                    computer vision tasks, such as image recognition and object detection.</li>
                                <li>Learn the process of deploying machine learning models into production
                                    environments for practical applications.</li>
                                <li>Collaboration and Communication: Develop skills in collaborating with team
                                    members, presenting findings, and effectively communicating complex concepts.
                                </li>
                            </ul>


                            <!-- <div class="global_section_content ouropinion_subcontent">
                                <h6>Career Path</h6> Cloud Services
                            </div> -->
                        </div>

                    </div>
                    <!-- <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
            <div class="career_popupcontent">Bachelor of Science or related field required. </div>

            <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
            <div class="career_popupcontent">hr@mitresource.com</div> -->
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>


    <mat-card style=" border-radius: 15px; border: 1px solid rgb(222,226,230);width: 99%;">
        <div mat-dialog-title class="d-flex justify-content-between">
            <h1 class="fw-bold text-dark p-1 mb-0 ">

            </h1>

            <div class="custom-button-close-icon">
                <button mat-mini-fab color="warn">
                    <mat-icon style="align-items: end; cursor: pointer"></mat-icon>
                </button>
            </div>
        </div>
        <mat-dialog-content class="mat-typography">
            <form class="container">
                <section>

                    <div class="d-flex">
                        <!-- <div class="col-3">
                <h2 class="headings  fw-bold">Company Details</h2>
              </div> -->
                        <div class="col-3">
                            <h2 style="color: #004F93;"></h2>
                        </div>
                    </div>

                    <section class="row">
                        <div class="col-md-4">
                            <mat-form-field appearance="outline" class="custom-mat-form-field">
                                <mat-label></mat-label>
                                <input type="text" id="name" matInput formControlName="name" required maxlength="50">
                                <mat-icon matSuffix></mat-icon>
                            </mat-form-field>


                        </div>
                        <div class="col-md-4">
                            <mat-form-field appearance="outline" class="custom-mat-form-field">
                                <mat-label>{{'OfficeOwner'}}</mat-label>
                                <input matInput formControlName="owner" id="owner" maxlength="50">
                                <mat-icon matSuffix></mat-icon>
                            </mat-form-field>

                        </div>
                        <div class="col-md-4">
                            <mat-form-field appearance="outline" class="custom-mat-form-field">
                                <mat-label>{{'Email'}}</mat-label>
                                <input matInput formControlName="email" id="email" minlength="4" maxlength="100"
                                    pattern="^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,10}$">
                                <mat-icon matSuffix></mat-icon>
                            </mat-form-field>
                        </div>
                    </section>
                </section>


            </form>
        </mat-dialog-content>
        <mat-dialog-actions class="justify-content-end">
            <section class="dialog-footer d-flex justify-content-end" style="padding: 15px;"
                style="padding: 0 0 15px 15px;">
                <div class="mx-2">
                    <button type="button" class="btn" style="width: 120px;border-radius: 12px;background-color: #ffffff;
          ;border: 1px solid #004F93;">
                        <span class="pb-2" style="color: #004F93;">{{'Clear'}}</span>
                    </button>
                </div>
                <div class="mx-4">
                    <button type="submit" mat-button>
                    </button>
                </div>
            </section>
        </mat-dialog-actions>
    </mat-card>
